import { api } from "../../../api/Middleware";
import {
  AUTOMATIONS_RULES_URL,
  AUTOMATIONS_URL,
  SCHEDULED_FOLLOWUPS_URL,
} from "../../../api/Urls";

export const getAutomations = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const url = queryParams.toString()
      ? `${AUTOMATIONS_URL}?${queryParams}`
      : AUTOMATIONS_URL;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching automations:", error);
    throw error;
  }
};

export const getAutomationById = async (id) => {
  try {
    const response = await api.get(AUTOMATIONS_URL + `${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching automation with id ${id}:`, error);
    throw error;
  }
};

export const createAutomation = async (data) => {
  try {
    const response = await api.post(AUTOMATIONS_URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating automation:", error);
    throw error;
  }
};

export const updateAutomation = async (id, data) => {
  try {
    const response = await api.put(AUTOMATIONS_URL + `${id}/`, data);
    return response.data;
  } catch (error) {
    console.error(`Error updating automation with id ${id}:`, error);
    throw error;
  }
};

export const deleteAutomation = async (id) => {
  try {
    await api.delete(AUTOMATIONS_URL + `${id}/`);
    return true;
  } catch (error) {
    console.error(`Error deleting automation with id ${id}:`, error);
    throw error;
  }
};

export const toggleAutomationActive = async (id) => {
  try {
    const response = await api.post(AUTOMATIONS_URL + `${id}/toggle_active/`);
    return response.data;
  } catch (error) {
    console.error(`Error toggling automation with id ${id}:`, error);
    throw error;
  }
};

export const duplicateAutomation = async (id) => {
  try {
    const response = await api.post(AUTOMATIONS_URL + `${id}/duplicate/`);
    return response.data;
  } catch (error) {
    console.error(`Error duplicating automation with id ${id}:`, error);
    throw error;
  }
};

export const getAutomationRules = async (automationId, agentId = null) => {
  try {
    // Precisamos modificar para usar a URL correta
    // Não há rota aninhada para regras no backend, então vamos filtrar pelo automationId
    const params = { automation: automationId };

    // Incluir agent_id se estivermos dentro do AgentHub
    if (agentId) {
      params.agent_id = agentId;
    }

    const response = await api.get(AUTOMATIONS_RULES_URL, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching rules for automation ${automationId}:`,
      error
    );
    throw error;
  }
};

export const getAutomationRuleById = async (automationId, ruleId) => {
  try {
    const response = await api.get(`${AUTOMATIONS_RULES_URL}${ruleId}/`);
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching rule ${ruleId} for automation ${automationId}:`,
      error
    );
    throw error;
  }
};

export const createAutomationRule = async (automationId, data) => {
  try {
    // Garantir que automation seja um ID, não um objeto
    const ruleData = {
      ...data,
      automation: Number(automationId), // Certifica que é um número
    };

    console.log(ruleData);

    // Verificar se template_action existe
    if (!ruleData.template_action) {
      console.error("template_action é obrigatório");
      throw new Error("template_action é obrigatório");
    }

    // Log para depuração
    console.log("Enviando dados para criar regra:", ruleData);

    // Enviar a requisição com os dados corretos
    const response = await api.post(AUTOMATIONS_RULES_URL, ruleData);
    return response.data;
  } catch (error) {
    console.error(`Error creating rule for automation ${automationId}:`, error);
    throw error;
  }
};

export const updateAutomationRule = async (automationId, ruleId, data) => {
  try {
    // Garantir que o automationId está nos dados

    data.automation = automationId;
    const response = await api.put(`${AUTOMATIONS_RULES_URL}${ruleId}/`, data);
    return response.data;
  } catch (error) {
    console.error(
      `Error updating rule ${automationId} for automation ${automationId}:`,
      error
    );
    throw error;
  }
};

export const deleteAutomationRule = async (automationId, ruleId) => {
  try {
    await api.delete(`${AUTOMATIONS_RULES_URL}${ruleId}/`);
    return true;
  } catch (error) {
    console.error(
      `Error deleting rule ${ruleId} for automation ${automationId}:`,
      error
    );
    throw error;
  }
};

export const toggleAutomationRuleActive = async (automationId, ruleId) => {
  try {
    const response = await api.post(
      `${AUTOMATIONS_RULES_URL}${ruleId}/toggle_active/`
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error toggling rule ${ruleId} for automation ${automationId}:`,
      error
    );
    throw error;
  }
};

// ===== SERVIÇOS PARA FOLLOW-UPS AGENDADOS =====

export const getScheduledFollowups = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const url = queryParams.toString()
      ? `${SCHEDULED_FOLLOWUPS_URL}?${queryParams}`
      : SCHEDULED_FOLLOWUPS_URL;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching scheduled followups:", error);
    throw error;
  }
};

export const getScheduledFollowupById = async (id) => {
  try {
    const response = await api.get(`${SCHEDULED_FOLLOWUPS_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching scheduled followup with id ${id}:`, error);
    throw error;
  }
};

export const getScheduledFollowupsStats = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params);
    const url = queryParams.toString()
      ? `${SCHEDULED_FOLLOWUPS_URL}stats/?${queryParams}`
      : `${SCHEDULED_FOLLOWUPS_URL}stats/`;
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching scheduled followups stats:", error);
    throw error;
  }
};

export const reprocessScheduledFollowup = async (id) => {
  try {
    const response = await api.post(
      `${SCHEDULED_FOLLOWUPS_URL}${id}/reprocess/`
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error reprocessing scheduled followup with id ${id}:`,
      error
    );
    throw error;
  }
};

export const deleteScheduledFollowup = async (id) => {
  try {
    await api.delete(`${SCHEDULED_FOLLOWUPS_URL}${id}/`);
    return true;
  } catch (error) {
    console.error(`Error deleting scheduled followup with id ${id}:`, error);
    throw error;
  }
};

export const deleteMultipleScheduledFollowups = async (ids) => {
  try {
    const response = await api.delete(
      `${SCHEDULED_FOLLOWUPS_URL}bulk_delete/`,
      {
        data: { ids: ids },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting multiple scheduled followups:', error);
    throw error;
  }
};
